import { get, isNil } from "lodash";
import PropTypes from "prop-types";
import { BiCheck, BiCopy, BiEnvelope } from "react-icons/bi";
import { formatLocalTime } from "utils/helpers/date";
import { fill } from "utils/helpers/template";
import { INVITATION_STATUSES } from "./setup";

const Invitation = ({
  invitation,
  email,
  name,
  labels,
  onCopyLink,
  onResend,
}) => {
  if (invitation.status === INVITATION_STATUSES.ACCEPTED)
    return (
      <div className="onboarding__banner onboarding__banner--success">
        <span className="onboarding__banner-icon" aria-hidden="true">
          <BiCheck size={20} />
        </span>
        <div className="onboarding__banner-text">
          <span className="onboarding__banner-title">
            {labels.ACCEPTED_TITLE}
            <span className="onboarding__badge onboarding__badge--done">
              {labels.ACCEPTED}
            </span>
          </span>
          <span>{fill(labels.ACCEPTED_TEXT, { name })}</span>
        </div>
      </div>
    );

  if (invitation.status !== INVITATION_STATUSES.PENDING) return null;

  const expiresAt = get(invitation, "expiresAt");
  return (
    <div className="onboarding__banner">
      <div className="onboarding__banner-head">
        <span className="onboarding__banner-icon" aria-hidden="true">
          <BiEnvelope size={20} />
        </span>
        <div className="onboarding__banner-text">
          <span className="onboarding__banner-title">
            {labels.TITLE}
            <span className="onboarding__badge onboarding__badge--todo">
              {labels.PENDING}
            </span>
          </span>
          <span>{fill(labels.TEXT, { email, name })}</span>
        </div>
        <div className="onboarding__banner-actions">
          <button
            type="button"
            className="onboarding__button onboarding__button--primary onboarding__button--icon"
            disabled={invitation.copying}
            onClick={onCopyLink}
          >
            {invitation.copied ? <BiCheck size={16} /> : <BiCopy size={16} />}
            {invitation.copied ? labels.COPIED : labels.COPY}
          </button>
          <button
            type="button"
            className="onboarding__button onboarding__button--outline"
            disabled={invitation.resending}
            onClick={onResend}
          >
            {invitation.resent ? labels.RESENT : labels.RESEND}
          </button>
        </div>
      </div>
      {invitation.url ? (
        <div className="onboarding__field">
          <label htmlFor="onboarding-invitation-link">{labels.LINK}</label>
          <input
            id="onboarding-invitation-link"
            type="text"
            readOnly
            value={invitation.url}
            className="onboarding__input onboarding__input--mono"
            onFocus={({ target }) => target.select()}
          />
        </div>
      ) : null}
      <p className="onboarding__hint">
        {isNil(expiresAt)
          ? labels.NOTE
          : `${fill(labels.VALID_UNTIL, {
              time: formatLocalTime(expiresAt),
            })} ${labels.NOTE}`}
      </p>
    </div>
  );
};

Invitation.propTypes = {
  invitation: PropTypes.shape({
    status: PropTypes.string,
    url: PropTypes.string,
    expiresAt: PropTypes.string,
    copied: PropTypes.bool,
    resent: PropTypes.bool,
    copying: PropTypes.bool,
    resending: PropTypes.bool,
  }).isRequired,
  email: PropTypes.string,
  name: PropTypes.string,
  labels: PropTypes.object.isRequired,
  onCopyLink: PropTypes.func.isRequired,
  onResend: PropTypes.func.isRequired,
};

Invitation.defaultProps = {
  email: "",
  name: "",
};

export default Invitation;
